export default __webpack_public_path__ + "static/media/EdwardPowlowski.d557f50e.svg";